import { useLayoutEffect, useRef } from "react";

import { DotLottieReact } from "@lottiefiles/dotlottie-react";

import { colorsPalettes } from "@similarweb/styles";
import { Box, Stack, Text } from "@similarweb/ui-components/foundations";

import { AssetsService } from "app/services/AssetsService";

import { useTextAnimation } from "./hooks/useTextAnimation";
import { animateAppearance } from "./utils/animateAppearance";

interface IProps {
    className?: string;
    texts?: readonly string[];
    size?: string;
    speedFactor?: number;
}

const AnimativeLoadingView = ({ className, texts = [], size = "255px", speedFactor }: IProps) => {
    const containerRef = useRef<HTMLDivElement>(null);

    const showText = texts.length > 0;

    useLayoutEffect(() => {
        const containerEl = containerRef.current;

        if (!containerEl) {
            return;
        }

        animateAppearance(containerEl, "appear");
    }, []);

    const animatedTextElRef = useTextAnimation({
        texts,
        speedFactor,
        enabled: showText,
    });

    return (
        <Stack
            className={className}
            ref={containerRef}
            alignItems="center"
        >
            <Box
                width={size}
                height={size}
            >
                <DotLottieReact
                    src={AssetsService.assetUrl("/images/sales-intelligence/insights_loader_animation.lottie")}
                    autoplay
                    loop
                />
            </Box>
            {showText ? (
                <Text
                    className="animative-loading-text"
                    fontVariant="h6"
                    color={colorsPalettes.carbon[250]}
                    textAlign="center"
                    padding="0 5px"
                    ref={animatedTextElRef}
                >
                    {texts[0]}
                </Text>
            ) : null}
        </Stack>
    );
};

export default AnimativeLoadingView;
